import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionListService } from '../subscription-list.service';
import { DatePipe } from '@angular/common';
import { UserFormBillDetails } from '../subscription-list.model';
import { ToastrService } from 'ngx-toastr';
import { ModalPopupSize, NotificationService } from '../../../../shared/services/notification.service';
import { PasswordVerificationComponent } from '../../../../shared/common-components/password-verification/password-verification.component';
import { AppPasswords } from '../../../../shared/enum/common-enum';

@Component({
  selector: 'app-bill-no-and-otp-popup',
  templateUrl: './bill-no-and-otp-popup.component.html',
  styleUrls: ['./bill-no-and-otp-popup.component.scss'],
  providers:[DatePipe]
})

export class BillNoAndOtpPopupComponent {
  selectedDate:any;
  data:any;
  rowData:any
  userForm = new UserFormBillDetails;
  isShowPassField:boolean= false;
  appPasswords = AppPasswords

 constructor(
    public activeModal: NgbActiveModal,
    public subscriptionListService:SubscriptionListService,
    public datePipe:DatePipe,
    public toaster :ToastrService,
    public notificationService:NotificationService
  ) {}

  ngOnInit(): void {
    const currentDate = new Date();
    this.selectedDate = this.datePipe.transform(currentDate, 'dd/MM/yyyy');

    if (this.data) {
      this.userForm = {
        id:this.data?.id,
        billDate: this.data?.billDate ? this.data?.billDate: this.selectedDate,
        billSeries: this.data?.billSeries || null,
        billNo: this.data?.billNo || null,
        amount: this.data?.amount || 0,
        discount: this.data?.discount || 0,
        netAmount: this.data?.netAmount || 0,
        tax: this.data?.tax || 0,
        finalAmt: this.data?.finalAmt || 0,
        reverseAmt: this.data?.reverseAmt || 0
      };
    }
  }

  save() {
    const data = {
      password: this.appPasswords.passForUpdateBillDetailsInSubscription,
      successMessage: 'Billing information has been updated.'
    };
    this.notificationService.openModalPopup(PasswordVerificationComponent, data, null, ModalPopupSize.MD, "", false, true)
      .then((result) => {
        if (result) {
          this.saveDetail();
        } else {

        }
      });
  }
  
  saveDetail() {
    const payload = { ...this.userForm }
    this.subscriptionListService.updateSubscriptionBillingDetail(payload).subscribe({
      next: (res) => {
        if (res?.isSuccess) {
          const result = { Success: true };
          this.activeModal.close(result);
        }
      },
      error: (err) => {
        console.error('Error saving:', err);
      }
    });
  }

  recalculate() {
    const payload = {
      id:this.userForm.id,
      amount: this.userForm.amount,
      discount: this.userForm.discount,
      tax: this.userForm.tax,
      finalAmt: this.userForm.finalAmt,
      reverseAmt: this.userForm.reverseAmt
    }
    this.subscriptionListService.recalculateSubscriptionBillingDetail(payload).subscribe({
      next: (res) => {
        if (res?.isSuccess) {
          this.userForm.discount = res.response.discount;
          this.userForm.netAmount = res.response.netAmount;
          this.userForm.tax = res.response.tax;
          this.userForm.finalAmt = res.response.finalAmt;
          this.userForm.reverseAmt = res.response.reverseAmt;
        }
      },
      error: (err) => {
        console.error('Error recalculating:', err);
      }
    });
  }
}
